import React, { useState, useEffect } from "react";
import classes from "./Gnb.module.css";
import { NavLink } from "react-router-dom";
import emogy from "../../assets/images/emojy/emojy3.png";

const Gnb = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [openSideBar, setOpenSideBar] = useState(false);
  useEffect(() => {
    setOpenSideBar(false);
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1200);
      setOpenSideBar(false);
    };
    // 초기 확인
    checkMobile();

    // resize 이벤트 등록
    window.addEventListener("resize", checkMobile);

    // 컴포넌트 언마운트 시 이벤트 제거
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  useEffect(() => {
    if (isMobile && openSideBar) {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }

    return () => {
      // 컴포넌트 언마운트 시 초기화
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    };
  }, [isMobile, openSideBar]);

  
  const openSideBarHandler = () => {
    if (isMobile) {
      setOpenSideBar(true);
    }
  };
  const closeSideBarHandler = () => {
    setOpenSideBar(false);
  };
  return (
    <>
      <div
        className={`${classes["side"]}  ${
          openSideBar && isMobile ? classes["show"] : ""
        }`}
      >
        <div className={classes["profile-box"]}>
          <div className={classes["profile-img-box"]}>
            <img src={emogy} />
          </div>
          <span className={classes["profile-name"]}>GORI</span>
        </div>

        <div className={classes["gnb"]}>
          <h2 className="hide">메인메뉴</h2>
          <ul className={classes["menu-list"]}>
            <ul>
              <li>
                <NavLink
                  to="/"
                  end
                  className={({ isActive }) =>
                    isActive ? `${classes["ac"]}` : undefined
                  }
                  onClick={() => closeSideBarHandler()}
                >
                  <i className="material-icons material-icons-round">home</i>
                  <span>HOME</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/about"
                  end
                  className={({ isActive }) =>
                    isActive ? `${classes["ac"]}` : undefined
                  }
                  onClick={() => closeSideBarHandler()}
                >
                  <i className="material-icons-round">account_circle</i>
                  ABOUT ME
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/portfolio"
                  end
                  className={({ isActive }) =>
                    isActive ? `${classes["ac"]}` : undefined
                  }
                  onClick={() => closeSideBarHandler()}
                >
                  <i className=" material-icons-round">sticky_note_2</i>
                  PORTFOLIO
                </NavLink>
              </li>
            </ul>
          </ul>
        </div>

        {isMobile && openSideBar && (
          <button
            className={classes["m-side-close-btn"]}
            onClick={() => closeSideBarHandler()}
          >
            <span className="material-icons-round">keyboard_backspace</span>
          </button>
        )}
      </div>
      {isMobile && openSideBar && (
        <div
          className={classes["m-gnb-bg"]}
          onClick={() => closeSideBarHandler()}
        ></div>
      )}

      {isMobile && (
        <button
          className={classes["side-box-btn"]}
          onClick={() => openSideBarHandler()}
        >
          <span className="hide">모바일 주 메뉴 열기</span>
          <span className={classes["top"]}></span>
          <span className={classes["mid"]}></span>
          <span className={classes["btm"]}></span>
        </button>
      )}
    </>
  );
};

export default Gnb;
